import { TbHome, TbBlocks, TbShoppingBag } from "react-icons/tb";
import { useLocation, useNavigate } from 'react-router-dom';
import { LogOutButton } from "../../auth/components/LogOut";

export default function NavbarVertical() {
  const location = useLocation();
  const navigate = useNavigate();

  // Configuración de items de navegación
  // Define las rutas, iconos normales y activos para cada item
  // Se usa color="currentColor" para que los iconos hereden el color del texto del padre
  const navMenuItems = [
    {
      labelText: 'Dashboard',
      iconPathLocation: '/',
      iconNormal: <TbHome size={24} color="currentColor" />,
      iconActive: <TbHome size={24} color="currentColor" />
    },
    {
      labelText: 'E-commerce',
      iconPathLocation: '/ecommerce',
      iconNormal: <TbShoppingBag size={24} color="currentColor" />,
      iconActive: <TbShoppingBag size={24} color="currentColor" />
    },
  ];

  return (
    <nav className="fixed top-0 left-0 py-4 w-16 h-screen bg-neutral-800 flex flex-col items-center justify-between">
      <ul className="p-2 space-y-2">
        {navMenuItems.map((item, index) => {
          const isActive = location.pathname === item.iconPathLocation;

          return (
            <li
              key={index}
              onClick={() => navigate(item.iconPathLocation)}
            >
              <div
                className={`flex items-center justify-center p-2 px-2 py-2 rounded-lg cursor-pointer 
                  ${isActive ? 'text-white' : ' hover:text-red-700'}
                  ${isActive ? 'bg-red-500' : 'bg-gray-50 hover:bg-gray-100'}
                `}
              >
                {isActive ? item.iconActive : item.iconNormal}
              </div>
            </li>
          );
        })}
      </ul>
      <ul className="p-2 space-y-2">
        <li>
          <LogOutButton className='BG-Nieve'/>
        </li>
      </ul>
    </nav>
  )
}